export const SHOW_SNACK_BAR = 'SHOW_SNACK_BAR';
export const HIDE_SNACK_BAR = 'HIDE_SNACK_BAR';

export function showSnackBar() {
  return { type: SHOW_SNACK_BAR };
}

export function hideSnackBar() {
  return { type: HIDE_SNACK_BAR };
}



// WEBPACK FOOTER //
// ./src/actions/globalActions.js